// GangaPage.jsx
// Ganga Foundations Private Limited Landing Page
import image1 from "../assets/GANGA TEASER-Final/6ba2b3a0-96bb-4852-8b09-0274877436fe-0.jpg";
import image2 from "../assets/GANGA TEASER-Final/6ba2b3a0-96bb-4852-8b09-0274877436fe-1.jpg";
import image3 from "../assets/GANGA TEASER-Final/6ba2b3a0-96bb-4852-8b09-0274877436fe-2.jpg";
import image4 from "../assets/GANGA TEASER-Final/6ba2b3a0-96bb-4852-8b09-0274877436fe-3.jpg";
import image5 from "../assets/GANGA TEASER-Final/6ba2b3a0-96bb-4852-8b09-0274877436fe-4.jpg";
import image6 from "../assets/GANGA TEASER-Final/6ba2b3a0-96bb-4852-8b09-0274877436fe-5.jpg";
import image7 from "../assets/GANGA TEASER-Final/6ba2b3a0-96bb-4852-8b09-0274877436fe-6.jpg";
import image8 from "../assets/GANGA TEASER-Final/6ba2b3a0-96bb-4852-8b09-0274877436fe-7.jpg";
import image9 from "../assets/GANGA TEASER-Final/6ba2b3a0-96bb-4852-8b09-0274877436fe-8.jpg";
import image10 from "../assets/GANGA TEASER-Final/6ba2b3a0-96bb-4852-8b09-0274877436fe-9.jpg";
import image11 from "../assets/GANGA TEASER-Final/6ba2b3a0-96bb-4852-8b09-0274877436fe-10.jpg";
import image12 from "../assets/GANGA TEASER-Final/6ba2b3a0-96bb-4852-8b09-0274877436fe-11.jpg";
import image13 from "../assets/GANGA TEASER-Final/6ba2b3a0-96bb-4852-8b09-0274877436fe-12.jpg";
import image14 from "../assets/GANGA TEASER-Final/6ba2b3a0-96bb-4852-8b09-0274877436fe-13.jpg";
import image15 from "../assets/GANGA TEASER-Final/6ba2b3a0-96bb-4852-8b09-0274877436fe-14.jpg";
import image16 from "../assets/GANGA TEASER-Final/6ba2b3a0-96bb-4852-8b09-0274877436fe-15.jpg";
import image17 from "../assets/GANGA TEASER-Final/6ba2b3a0-96bb-4852-8b09-0274877436fe-16.jpg";
import image18 from "../assets/GANGA TEASER-Final/6ba2b3a0-96bb-4852-8b09-0274877436fe-17.jpg";
import image19 from "../assets/GANGA TEASER-Final/6ba2b3a0-96bb-4852-8b09-0274877436fe-18.jpg";
import image20 from "../assets/GANGA TEASER-Final/6ba2b3a0-96bb-4852-8b09-0274877436fe-19.jpg";
import image21 from "../assets/GANGA TEASER-Final/6ba2b3a0-96bb-4852-8b09-0274877436fe-20.jpg";
import hero from "../assets/hero.jpg";
import company1 from "../assets/company.webp";

import React, { useState, useEffect } from "react";
import API_URL from "../config";

/////////////////// photo gallery /////////////////
import photo1 from "../assets/ganga-image/1.jpeg";
import photo2 from "../assets/ganga-image/2.jpeg";
import photo3 from "../assets/ganga-image/3.jpeg";
import photo4 from "../assets/ganga-image/4.jpeg";
import photo5 from "../assets/ganga-image/5.jpeg";
import photo6 from "../assets/ganga-image/6.jpeg";
import photo7 from "../assets/ganga-image/7.jpeg";
import photo8 from "../assets/ganga-image/8.jpeg";
import photo9 from "../assets/ganga-image/9.jpeg";
import photo10 from "../assets/ganga-image/10.jpeg";
import photo11 from "../assets/ganga-image/11.jpeg";
import photo12 from "../assets/ganga-image/12.jpeg";
import photo13 from "../assets/ganga-image/13.jpeg";
import photo14 from "../assets/ganga-image/14.jpeg";
import photo15 from "../assets/ganga-image/15.jpeg";
import photo16 from "../assets/ganga-image/16.jpeg";

///////////////////// pdf  ///////////
import samplePDF from "../assets/pdf/Liquidation Order.pdf";
import samplePDF5 from "../assets/pdf/Bidding Document - Lot 1 (GC).pdf";
import samplePDF8 from "../assets/pdf/Revised List of Stakeholders - Ganga.pdf";
import eAuctionLot23 from "../assets/pdf/E-auction Process Document (Lot-2,3).pdf";

import { FaChevronDown, FaChevronUp, FaTimes } from "react-icons/fa";
import GangaVideoPlayer from "../Component/GangaVideoPlayer";

// Fallback local attachments (used when API has no uploaded attachments)
const localAttachments = [
  {
    title: "ORDERS",
    subtitle: "Liquidation Order",
    files: [
      { name: "Liquidation Order.pdf", url: samplePDF, icon: "📄" },
    ],
  },
  {
    title: "E- Auction",
    subtitle: "10th E- Auction",
    files: [
      { name: "Bidding Document - Lot 1 (GC).pdf", url: samplePDF5, icon: "📑" },
      { name: "E-auction Process Document (Lot-2,3).pdf", url: eAuctionLot23, icon: "📑" },
    ],
  },
  {
    title: "List of Stakeholders",
    subtitle: "List of Stakeholders dated",
    files: [
      { name: "Revised List of Stakeholders - Ganga.pdf", url: samplePDF8, icon: "📝" },
    ],
  },
  {
    title: "Assets Photos",
    subtitle: "Mall Photos",
    files: [
      { name: "Photo 1", url: photo1, icon: "📷", type: "image" },
      { name: "Photo 2", url: photo2, icon: "📷", type: "image" },
      { name: "Photo 3", url: photo3, icon: "📷", type: "image" },
      { name: "Photo 4", url: photo4, icon: "📷", type: "image" },
      { name: "Photo 5", url: photo5, icon: "📷", type: "image" },
      { name: "Photo 6", url: photo6, icon: "📷", type: "image" },
      { name: "Photo 7", url: photo7, icon: "📷", type: "image" },
      { name: "Photo 8", url: photo8, icon: "📷", type: "image" },
      { name: "Photo 9", url: photo9, icon: "📷", type: "image" },
      { name: "Photo 10", url: photo10, icon: "📷", type: "image" },
      { name: "Photo 11", url: photo11, icon: "📷", type: "image" },
      { name: "Photo 12", url: photo12, icon: "📷", type: "image" },
      { name: "Photo 13", url: photo13, icon: "📷", type: "image" },
      { name: "Photo 14", url: photo14, icon: "📷", type: "image" },
      { name: "Photo 15", url: photo15, icon: "📷", type: "image" },
      { name: "Photo 16", url: photo16, icon: "📷", type: "image" },
    ],
  },
];

// Convert API attachments to dropdown format, merge with local fallback
const buildAttachments = (apiAttachments) => {
  if (!apiAttachments) return localAttachments;

  const sections = [];

  const apiOrders = apiAttachments.orders || [];
  const orderFiles = apiOrders.length > 0
    ? apiOrders.map(f => ({ name: f.name, url: f.url, icon: "📄" }))
    : localAttachments[0].files;
  sections.push({ title: "ORDERS", subtitle: "Liquidation Order", files: orderFiles });

  const apiEAuction = apiAttachments.eAuction || [];
  const eAuctionFiles = apiEAuction.length > 0
    ? apiEAuction.map(f => ({ name: f.name, url: f.url, icon: "📑" }))
    : localAttachments[1].files;
  sections.push({ title: "E- Auction", subtitle: "10th E- Auction", files: eAuctionFiles });

  const apiStakeholders = apiAttachments.stakeholders || [];
  const stakeholderFiles = apiStakeholders.length > 0
    ? apiStakeholders.map(f => ({ name: f.name, url: f.url, icon: "📝" }))
    : localAttachments[2].files;
  sections.push({ title: "List of Stakeholders", subtitle: "List of Stakeholders dated", files: stakeholderFiles });

  const apiPhotos = apiAttachments.assetsPhotos || [];
  const photoFiles = apiPhotos.length > 0
    ? apiPhotos.map(f => ({ name: f.name, url: f.url, icon: "📷", type: "image" }))
    : localAttachments[3].files;
  sections.push({ title: "Assets Photos", subtitle: "Mall Photos", files: photoFiles });

  return sections;
};

const DropdownList = ({ data }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const [fullscreenImage, setFullscreenImage] = useState(null);

  const toggleDropdown = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 p-4 bg-gradient-to-r from-purple-50 to-indigo-50 rounded-xl h-[600px] overflow-y-auto">
        {data.map((section, index) => (
          <div
            key={index}
            className="bg-white shadow-md rounded-xl border p-4 flex flex-col transition-all duration-300"
            style={{
              minHeight: openIndex === index ? "auto" : "80px",
              height: openIndex === index ? "auto" : "80px",
            }}
          >
            <div
              className="flex justify-between items-start cursor-pointer gap-3"
              onClick={() => toggleDropdown(index)}
            >
              <div className="flex-1 min-w-0 pr-2">
                <h3 className="font-semibold text-gray-800">{section.title}</h3>
                {section.subtitle && (
                  <p className="text-sm text-gray-500 mt-1">{section.subtitle}</p>
                )}
              </div>
              <div className="flex-shrink-0 mt-1">
                {openIndex === index ? (
                  <FaChevronUp className="text-indigo-600" />
                ) : (
                  <FaChevronDown className="text-indigo-600" />
                )}
              </div>
            </div>

            {openIndex === index && (
              <ul className="mt-3 space-y-2 overflow-y-auto flex-1 pr-1">
                {section.files.map((file, i) => (
                  <li key={i}>
                    {file.type === "image" ? (
                      <div
                        className="flex items-center space-x-2 cursor-pointer"
                        onClick={() => setFullscreenImage(file.url)}
                      >
                        <span>{file.icon}</span>
                        <span>{file.name}</span>
                      </div>
                    ) : (
                      <a
                        href={file.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center space-x-2 text-gray-700 hover:text-indigo-600"
                      >
                        <span>{file.icon}</span>
                        <span>{file.name}</span>
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>

      {fullscreenImage && (
        <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50">
          <button
            className="absolute top-6 right-6 text-white text-3xl hover:text-gray-300"
            onClick={() => setFullscreenImage(null)}
          >
            <FaTimes />
          </button>
          <img
            src={fullscreenImage}
            alt="Preview"
            className="max-w-5xl max-h-[90%] rounded-lg shadow-lg"
          />
        </div>
      )}
    </>
  );
};

const Hero = ({ company }) => (
  <header className="relative h-120 w-full overflow-hidden shadow-lg">
    <img
      src={company.companyPicture || hero}
      alt="Ganga Foundation"
      className="absolute inset-0 h-full w-full object-cover"
    />
    <div className="absolute inset-0 bg-gradient-to-r from-indigo-black to-purple-gray" />
    <div className="absolute bottom-10 left-10 text-white">
      <h1 className="text-4xl font-extrabold drop-shadow-lg tracking-wide">
        {company.companyName}
      </h1>
      <p
        className="text-md max-w-xl mt-2 text-white font-medium"
        style={{ textShadow: "1px 1px 3px rgba(0,0,0,0.8)" }}
      >
        {company.address}
      </p>
    </div>
  </header>
);

const CompanyInfo = ({ company }) => (
  <section className="flex flex-col md:flex-row gap-6 p-6 bg-gradient-to-br from-white to-indigo-50 rounded-xl shadow">
    <div className="flex-1 rounded-xl border bg-white p-6 shadow-md hover:shadow-lg transition">
      <h2 className="font-bold mb-3 text-xl text-indigo-700">Company Profile</h2>
      <p className="text-sm leading-relaxed whitespace-pre-line text-gray-700">
        {company.companyProfile}
      </p>

      <div className="mt-4">
        <h3 className="font-semibold text-purple-700">Liquidation / Legal</h3>
        <p className="text-sm mt-1 text-gray-600">{company.liquidOrder}</p>
        <p className="text-sm mt-2 whitespace-pre-line text-gray-600">
          {company.liquidator}
        </p>
      </div>
    </div>

    <aside className="w-full md:w-80 rounded-xl border p-5 bg-white shadow-md">
      <h2 className="font-bold mb-3 text-indigo-700">Quick Info</h2>
      <div className="text-sm space-y-2 text-gray-700">
        <p><strong>Name:</strong> {company.quickInfo?.name || company.companyName}</p>
        <p><strong>Address:</strong> {company.quickInfo?.address || company.address}</p>
        <p><strong>CIN:</strong> {company.quickInfo?.cin || company.cin}</p>
      </div>
      <img
        src={company.quickInfo?.picture || company1}
        alt="thumbnail"
        className="mt-4 h-44 w-full object-cover rounded-lg shadow"
      />
    </aside>
  </section>
);

const Slide = ({ apiSliderImages }) => {
  // Use API slider images if available, otherwise use local bundled images
  const localImages = [
    image1, image2, image3, image4, image5, image6, image7, image8, image9, image10,
    image11, image12, image13, image14, image15, image16, image17, image18, image19, image20, image21,
  ];

  const images = (apiSliderImages && apiSliderImages.length > 0)
    ? apiSliderImages.map(img => img.url)
    : localImages;

  const [index, setIndex] = useState(0);

  const prevSlide = () => {
    setIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const nextSlide = () => {
    setIndex((prev) => (prev + 1) % images.length);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="h-[800px] m-6 p-5 rounded-2xl overflow-hidden relative shadow-xl bg-white">
      <img
        src={images[index]}
        alt="carousel"
        className="h-[100%] w-full object-contain transition-all duration-700"
      />
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/50 text-white px-4 py-1 rounded-full text-sm font-medium shadow-lg">
        {index + 1} / {images.length}
      </div>
      <button
        onClick={prevSlide}
        className="absolute top-1/2 left-6 -translate-y-1/2 bg-gradient-to-r from-purple-500 to-indigo-600 text-white p-3 rounded-full shadow-lg hover:scale-110 hover:shadow-2xl transition-transform"
      >
        <span className="text-2xl font-bold">&#8249;</span>
      </button>
      <button
        onClick={nextSlide}
        className="absolute top-1/2 right-6 -translate-y-1/2 bg-gradient-to-r from-indigo-600 to-purple-500 text-white p-3 rounded-full shadow-lg hover:scale-110 hover:shadow-2xl transition-transform"
      >
        <span className="text-2xl font-bold">&#8250;</span>
      </button>
    </div>
  );
};

const WhoWeAre = ({ whoWeAre }) => (
  <section className="px-6 py-12 bg-gradient-to-r from-indigo-50 to-purple-50 rounded-xl">
    <h3 className="text-3xl font-bold mb-8 text-center text-indigo-700">Who We Are</h3>
    <div className="p-6 bg-white rounded-xl shadow-md hover:shadow-lg transition text-gray-700 space-y-4 leading-relaxed">
      {whoWeAre?.description ? (
        <div 
          className="description-content"
          dangerouslySetInnerHTML={{ __html: whoWeAre.description }} 
        />
      ) : (
        <p className="text-gray-400 italic">No description available.</p>
      )}
      
      <div className="mt-8 pt-6 border-t border-indigo-100 grid grid-cols-1 md:grid-cols-2 gap-6">
        {whoWeAre?.email && (
          <div>
            <h4 className="font-bold text-indigo-700 text-sm uppercase tracking-wider mb-1">Email</h4>
            <a href={`mailto:${whoWeAre.email}`} className="text-indigo-600 hover:text-indigo-800 transition underline decoration-2 underline-offset-4">
              {whoWeAre.email}
            </a>
          </div>
        )}
        {whoWeAre?.phone && (
          <div>
            <h4 className="font-bold text-indigo-700 text-sm uppercase tracking-wider mb-1">Phone</h4>
            <p className="text-gray-800 font-medium">{whoWeAre.phone}</p>
          </div>
        )}
      </div>
    </div>
  </section>
);

const VideoSection = ({ videoUrl }) => {
  if (!videoUrl) return <GangaVideoPlayer />;

  const ytMatch = videoUrl.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
  if (ytMatch) {
    return (
      <div className="relative w-full" style={{ paddingBottom: "56.25%", height: 0 }}>
        <iframe
          className="absolute inset-0 w-full h-full"
          src={`https://www.youtube.com/embed/${ytMatch[1]}?autoplay=1&mute=1&loop=1&playlist=${ytMatch[1]}`}
          title="Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="relative w-full h-screen overflow-hidden">
      <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover">
        <source src={videoUrl} type="video/mp4" />
      </video>
    </div>
  );
};

const Footer = ({ company }) => (
  <footer className="bg-gradient-to-r from-indigo-600 to-purple-600 px-6 py-4 text-center text-sm text-white rounded-t-xl">
    Registered Office: {company.address} &bull; Contact: {company.whoWeAre?.phone || "73730-52341 / 94888-10404"}
  </footer>
);

export default function GangaPage() {
  const [caseData, setCaseData] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/insolvency-cases/ganga`)
      .then(res => res.ok ? res.json() : null)
      .then(data => { if (data) setCaseData(data); })
      .catch(err => console.error("Error fetching Ganga data:", err));
  }, []);

  // Fallback company data while loading or if API fails
  const company = caseData || {
    companyName: "GANGA FOUNDATIONS PRIVATE LIMITED",
    cin: "U45201TN2004PTC054417",
    address: "NO.114A AND 114B, PAPER MILLS ROAD, PERAMBUR, CHENNAI – 600011, TAMILNADU",
    companyProfile: "GANGA FOUNDATIONS PRIVATE LIMITED, incorporated on October 08, 2004, is a ISO 9001:2015 certified company.",
    liquidOrder: "Liquidation Order No. IA/(IBC)/80/CHE/2023",
    liquidator: "CA Mahalingam Suresh Kumar",
    quickInfo: {},
    whoWeAre: { description: "", email: "", phone: "73730-52341 / 94888-10404" },
    attachments: {},
    sliderImages: [],
    videoUrl: "",
  };

  const attachmentData = buildAttachments(company.attachments);

  return (
    <div className="w-full min-h-screen bg-gray-100 space-y-8">
      <Hero company={company} />
      <div className="px-6 py-3 font-semibold bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded shadow-md">
        CIN: {company.cin}
      </div>
      <CompanyInfo company={company} />
      <VideoSection videoUrl={company.videoUrl} />
      <Slide apiSliderImages={company.sliderImages} />
      <WhoWeAre whoWeAre={company.whoWeAre} />
      <div className="px-6">
        <h3 className="text-3xl font-bold mb-8 text-center text-indigo-700">Attachments</h3>
        <DropdownList data={attachmentData} />
      </div>
      <Footer company={company} />
    </div>
  );
}
